import React from "react";
import "./Shopbycat.css"

const Shopbycat = () => {
  return (
    <>
      <p className="shopbycatHeading">Shop by Category</p>
      <div className="shopbycat">
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770" alt=""
            />
          </div>
          <p className="cat-name">Necklaces</p>
        </div>
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770"alt=""
            />
          </div>
          <p className="cat-name">Earrings</p>
        </div>
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770" alt=""
            />
          </div>
          <p className="cat-name">Bracelets</p>
        </div>
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770"alt=""
            />
          </div>
          <p className="cat-name">Pendants</p>
        </div>
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770"alt=""
            />
          </div>
          <p className="cat-name">Chokers</p>
        </div>
        <div className="cat">
          <div className="cat-img">
            <img
              src="https://www.giva.co/cdn/shop/t/113/assets/prod-cat-sets_small.jpg?v=19410953192038609691711609770"alt=""
            />
          </div>
          <p className="cat-name">Chains</p>
        </div>
      </div>
    </>
  );
};

export default Shopbycat;
